import * as React from "react";
function findPathParent(obj, arr) {
  if (!obj)
    return;
  arr.push(obj.type);
  const children = obj.props?.children;
  if (obj.type === "path" && !children) {
    return arr.pop();
  } else if (typeof children === "object") {
    if (Array.isArray(children)) {
      for (let i = 0; i < children.length; i++) {
        const result = findPathParent(children[i], arr);
        if (result) {
          break;
        }
      }
    } else {
      findPathParent(children, arr);
    }
  } else {
    arr.pop();
  }
}
function addNewStyle(newStyle) {
  let styleElement = document.getElementById("styles_js");
  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.id = "styles_js";
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }
  styleElement.appendChild(document.createTextNode(newStyle));
}
function changePathStyle(props, arr, id) {
  if (!props)
    return;
  const str = arr.join(" ");
  const root = arr[0];
  const others = arr.slice(1);
  if (props.color) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props.color + "}");
  }
  if (props["data-hovercolor"]) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovercolor"] + "}");
  }
  if (props["data-activecolor"]) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activecolor"] + "}");
  }
  if (Array.isArray(props["data-twotonecolor"])) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-twotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-twotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-hovertwotonecolor"])) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovertwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-hovertwotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-activetwotonecolor"])) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activetwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-activetwotonecolor"][1] + "}");
  }
  if (props.width) {
    addNewStyle(root + "#" + id + "{width: " + props.width + "}");
  }
  if (props.height) {
    addNewStyle(root + "#" + id + "{height: " + props.height + "}");
  }
}
const isArrayContainsElement = (arr1, arr2) => {
  for (let i = 0; i < arr2.length; i++) {
    if (arr1.includes(arr2[i])) {
      return true;
    }
  }
  return false;
};
const OPTIONS = ["color", "data-activecolor", "data-hovercolor", "data-twotonecolor", "data-hovertwotonecolor", "data-activetwotonecolor", "width", "height"];
const SvgEyeInvisible = (props) => {
  const isSetOptions = isArrayContainsElement(Object.keys(props), OPTIONS);
  const svg = /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", id: "eye-invisible_svg_plugin_66131", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Group 4" }, /* @__PURE__ */ React.createElement("g", { id: "Union" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.04506 2.28234C0.947432 2.18471 0.947432 2.02642 1.04506 1.92879L1.92895 1.0449C2.02658 0.947271 2.18487 0.947272 2.2825 1.0449L16.955 15.7174C17.0526 15.815 17.0526 15.9733 16.955 16.0709L16.0711 16.9548C15.9735 17.0524 15.8152 17.0524 15.7175 16.9548L12.8942 14.1315C9.8093 15.9255 5.73901 15.4114 3.21896 12.5889L0.720614 9.79076C0.318349 9.34023 0.318348 8.65951 0.720614 8.20897L3.21896 5.41083C3.37043 5.24118 3.5275 5.07987 3.68963 4.9269L1.04506 2.28234ZM4.92785 6.16513C4.78845 6.29434 4.65376 6.43142 4.52435 6.57636L2.3605 8.99987L4.52435 11.4234C6.36434 13.4842 9.27181 13.9555 11.6001 12.8374L10.457 11.6943C10.0237 11.9291 9.52747 12.0624 9.00006 12.0624C7.30869 12.0624 5.93756 10.6912 5.93756 8.99987C5.93756 8.47246 6.07088 7.9762 6.30565 7.54293L4.92785 6.16513ZM7.68956 8.92684C7.68823 8.95101 7.68756 8.97536 7.68756 8.99987C7.68756 9.72474 8.27519 10.3124 9.00006 10.3124C9.02457 10.3124 9.04892 10.3117 9.0731 10.3104L7.68956 8.92684Z", fill: "#E0E0E0" }), /* @__PURE__ */ React.createElement("path", { d: "M5.93746 3.44994L7.30324 4.81572C9.44312 4.18807 11.8672 4.77495 13.4756 6.57635L15.6395 8.99987L13.6809 11.1934L14.9204 12.4328L17.2793 9.79076C17.6816 9.34022 17.6816 8.65951 17.2793 8.20897L14.781 5.41083C12.4817 2.83562 8.89187 2.18199 5.93746 3.44994Z", fill: "#E0E0E0" }), /* @__PURE__ */ React.createElement("path", { d: "M8.47051 5.98299L12.0169 9.52942C12.0469 9.35741 12.0626 9.18046 12.0626 8.99987C12.0626 7.3085 10.6914 5.93737 9.00006 5.93737C8.81947 5.93737 8.64252 5.953 8.47051 5.98299Z", fill: "#E0E0E0" }))));
  if (isSetOptions) {
    const parents = [];
    findPathParent(svg, parents);
    const id = svg.props.id;
    changePathStyle(props, parents, id);
  }
  return svg;
};
export default SvgEyeInvisible;
